import {
  Component,
  HostListener,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import {
  ScrollToConfigOptions,
  ScrollToService,
} from '@nicky-lenaers/ngx-scroll-to';

import { NgbCarouselConfig } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-our-story-page',
  templateUrl: './our-story-page.component.html',
  styleUrls: ['./our-story-page.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class OurStoryPageComponent implements OnInit {
  items: NodeListOf<Element>;
  constructor(
    config: NgbCarouselConfig,
    private title: Title,
    private meta: Meta,
    private scrollToService: ScrollToService
  ) {
    config.interval = 10000;
    config.wrap = false;
    config.keyboard = false;
    config.pauseOnHover = false;

    this.meta.addTag({
      name: 'description',
      content:
        'Easy event calendar management for senior living — with smart activity planning, digital and print newsletters, digital signage, and family communications.',
    });
    this.title.setTitle('TSOLife | Resident Engagement for Assisted Living');
  }

  ngOnInit() {
    this.items = document.querySelectorAll('.timeline li');
  }

  @HostListener('window:load', ['$event'])
  @HostListener('window:resize', ['$event'])
  @HostListener('window:scroll', ['$event'])
  onWindowScroll() {
    for (let i = 0; i < this.items.length; i++) {
      if (this.isElementInViewport(this.items[i])) {
        this.items[i].classList.add('in-view');
      }
    }
  }

  isElementInViewport(el: Element) {
    const rect = el.getBoundingClientRect();
    const docEl = document.documentElement;
    const marginTop = parseInt(window.getComputedStyle(el).marginTop, 10);
    const marginBottom = parseInt(window.getComputedStyle(el).marginBottom, 10);
    const top = rect.top - Math.max(marginTop, 0);
    const bottom = rect.bottom - Math.max(marginBottom, 0);
    const isFullyVisible = top >= 0 && bottom <= docEl.clientHeight;
    const isPartiallyVisible = top < docEl.clientHeight && bottom >= 0;
    return isFullyVisible || isPartiallyVisible;
  }

  triggerScrollTo(target: string) {
    const config: ScrollToConfigOptions = {
      target,
    };
    this.scrollToService.scrollTo(config);
  }
}
